import { render, staticRenderFns } from "./PayoutDocuments.vue?vue&type=template&id=8c554714&scoped=true"
import script from "./PayoutDocuments.vue?vue&type=script&lang=ts"
export * from "./PayoutDocuments.vue?vue&type=script&lang=ts"
import style0 from "./PayoutDocuments.vue?vue&type=style&index=0&id=8c554714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c554714",
  null
  
)

export default component.exports